import { useAuth } from "./useAuth";


export const useUser = () => {
  return useAuth().user;
}